import React from 'react'
import { NavLink } from 'react-router-dom'

const Footer = () => {
    return (
        <section className='pb-3'>
            <div className="container">
                <div className="row mb__5 sm-2">
                    <div className="mb-5 mb-md-0 col-md-2 text-center text-md-left">
                        <img src="./../images/Listopagologo.png" alt="Logo ListoPago" style={{ width: "100px", height: "auto" }} />
                    </div>
                    <div className="mb-4 mb-md-0 col-md-5">
                        <div className="row">
                            <div className="col-6">
                                <h5 className='semi-bold font__size--14 text__14-1024 mb-3'>Menú</h5>
                                <ul className='list__foooter-menu'>
                                    <li>
                                        <NavLink to="/" className='medium font__size--14 text__14-1024 color__gray-1'>Inicio</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/about" className='medium font__size--14 text__14-1024 color__gray-1'>Nosotros</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/planes" className='medium font__size--14 text__14-1024 color__gray-1'>Planes</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/faq" className='medium font__size--14 text__14-1024 color__gray-1'>Soporte</NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-6">
                                <h5 className='semi-bold font__size--14 text__14-1024 mb-3'>Legal</h5>
                                <ul className='list__foooter-menu'>
                                    <li>
                                        <NavLink to="/aviso-de-privacidad" className='medium font__size--14 text__14-1024 color__gray-1'>Aviso de privacidad</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/terminos-de-servicio" className='medium font__size--14 text__14-1024 color__gray-1'>Términos de servicio</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="mb-4 mb-md-0 col-6 col-md">
                        <h5 className='semi-bold font__size--14 text__14-1024 mb-3'>Descarga nuestra app</h5>

                        <ul className='list__foooter-menu'>
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.listopago.app" target="_blank" rel="noopener noreferrer">
                                    <img src="./../images/safdd (2).png" alt="Descargar en Google Play" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="mb-4 mb-md-0 col-6 col-md">
                        <h5 className='semi-bold font__size--14 text__14-1024 mb-3'>Conéctate con nosotros</h5>
                        <ul className='list__foooter-sosmed'>
                            <li>
                                <a href="https://www.tiktok.com/@listo.pago" target="_blank" rel="noopener noreferrer">
                                    <img src="./../images/tiktok.png" alt="TikTok" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/listo.pago/" target="_blank" rel="noopener noreferrer">
                                    <img src="./../images/instagram1.png" alt="Instagram" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=61587252160532" target="_blank" rel="noopener noreferrer">
                                    <img src="./../images/facebook-48.png" alt="Facebook" />
                                </a>
                            </li>
                        </ul>
                        <a
                            href="https://wa.me/573245576260"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center mt-3 text-decoration-none color__gray-1"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={{ width: "22px", height: "22px", marginRight: "8px", flexShrink: 0 }}>
                                <path d="M16 0C7.163 0 0 7.163 0 16c0 2.833.737 5.49 2.027 7.8L0 32l8.43-2.01A15.938 15.938 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0z" fill="#25D366"/>
                                <path d="M23.5 19.8c-.3-.15-1.8-.9-2.08-1-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.68-1.63-.93-2.23-.24-.58-.49-.5-.68-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.4-.07-.12-.27-.19-.57-.34z" fill="#fff"/>
                            </svg>
                            <span className="medium font__size--14 text__14-1024">324 557 6260</span>
                        </a>
                    </div>
                </div>
                <div className="text-center medium font__size--14 text__14-1024">
                    © 2026 ListoPago inc
                </div>
            </div>
        </section>
    )
}

export default Footer